<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.modifiers') }} > {{ $t('sidebar.create') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.modifiers')"/>
            <modifier
              :validation="validation"
              :data="modifier"
              @data="setForm"
            />
          </div>
        </section>

        <section
          v-if="items.length > 0 && modifier.name"
          class="assign-items mt-3"
          style="margin-bottom: 20px;">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.assignitems') + ' ('+assignitems.length+')'"/>
            <div class="col-md-12 row align-items-center no-padding no-margin subheader-assign">
              <div class="col no-padding">{{ $t('message.productlist') }}</div>
            </div>
            <div
              v-for="(item, index) in items"
              :class="{ active: item.active}"
              class="col-md-12 row align-items-center no-padding no-margin item"
              @click="toggleAssign(item)">
              <div class="col">
                {{ item.product_name }}
              </div>
              <div class="col text-right">
                <span
                  v-for="(_item, index) in item.modifiers"
                  class="comma">
                  {{ _item.modifier_name }}
                </span>
                <span v-if="item.active">
                  {{ modifier.name }}
                </span>
                <i class="fas fa-check-circle"/>
                <i class="far fa-circle"/>
              </div>
            </div>
          </div>
        </section>

        <section class="mt-4">
          <div class="col-md-12 no-padding">
            {{ $t('message.applyitemtopos', {item: $t('sidebar.modifiers')}) }}
            <a
              href="https://www.treesoft.io/th/manual/product#modify"
              target="_blank">
              {{ $t('button.learnmore') }}
              <i class="fas fa-external-link-alt"/>
            </a>
          </div>
        </section>

        <section class="action-bar">
          <div
            v-if="!$store.state.app.loading"
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light">{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              @click="validation++">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" disabled>{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </section>
      </template>

    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'

export default {
  name: 'CategoryNew',
  mixins: [discardFormMixin],
  data () {
    return {
      ready: false,

      items: [],
      assignitems: [],

      validation: 0,
      modifier: {
        name: null,
        options: [],
        is_required: false,
        min_required_count: 0,
        max_required_count: 0,
      },
    }
  },
  computed: {
    ...mapGetters({
      products: 'getProducts',
    }),
    form () {
      return {
        items: this.items,
        assignitems: this.assignitems,
        modifier: this.modifier,
      }
    },
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    items: {
      handler: function (after) {
        let items = after
        this.updateAssignItems(items)
      },
      deep: true,
    },
    modifier: {
      handler: function (value) {

      },
      deep: true,
    },
  },
  beforeCreate: function () { // clear states

  },
  created: async function () { // call api to get data and set state
    // get products
    await this.$store.dispatch('getProducts')
    // set items
    this.setItems(null, this.products)
    // update assignitems
    this.updateAssignItems(this.items)
    // set ready
    this.ready = true
  },
  beforeMount: function () { // set states ui
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.products.title'),
      current: {
        app_name: 'products',
        app_id: 2,
        module_id: 3,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 3,
      submenuAtIdx: 1,
    })
  },
  mounted: function () { // run script

  },
  updated: function () { // re-rendered html

  },
  destroyed: function () { // leave this page
    this.leavePage(this.$Progress, ['clearProducts'])
  },
  methods: {
    toggleAssign (item) {
      if (!this.modifier.name) {
        return
      }
      item.active = !item.active
    },
    setItems (category, products) {
      this.items = []
      for (let i in products) {
        let product = products[i]
        var active = false
        if (category) {
          if (category.category_id == product.category_id) {
            active = true
          }
        }
        this.items.push({
          product_id: product.product_id,
          product_name: product.product_name,
          modifiers: product.modifiers,
          active: active,
        })
      }
    },
    updateAssignItems (items) {
      this.assignitems = []
      for (let i in items) {
        let item = items[i]
        if (item.active) {
          this.assignitems.push({
            product_id: item.product_id,
          })
        }
      }
    },
    /*
     *  this function response when validation is chanaged, <modifier></modifier> component
     */
    setForm (isValid, data) {
      if (!isValid) {
        return $('html, body').animate({ scrollTop: 0 }, 'slow')
      }

      if (this.assignitems.length > 0) {
        data['assign'] = this.assignitems
      }

      this.save(data)
    },
    async save (data) {
      const payload = {
        ...data,
        options: data.options.map((item, index) => {
          return {
            ...item,
            index: index,
          }
        }),
      }
      let res = await this.$store.dispatch('insertModifier', payload)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: data.modifier_name }),
          color: 'success',
          icon: 'cloud',
        })
        // go to GoodsIssueAll page
        return this.$router.push({
          name: 'ModifierAll',
          query: {
            ignoreDiscardAlert: true,
          },
        })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/items/modifier/New.vue